var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { usePersonTypeInternalName } from "../../../Hooks/usePersonType";
import { useVirtualizedApp } from "../../../Hooks/useVirtualizedApp";
import PersonTypeService from "../../../../Services/PersonType.service";
import PersonDomainService from "../../../../Domain/Person/Person.service";
import PersonService from "../../../../Services/Person.service";
import useConfiguration from "../../../Hooks/useConfiguration";
import PersonTypeDomainService from "../../../../Domain/PersonType/PersonType.service";
import useParams from "../../../Hooks/useParams";
const LinkToPerson = (_a) => {
    var _b;
    var { affiliationId, name, children, virtualizedApp, tabId, personType, className, personIsInAppAndPersonType, queryParams, target } = _a, otherProps = __rest(_a, ["affiliationId", "name", "children", "virtualizedApp", "tabId", "personType", "className", "personIsInAppAndPersonType", "queryParams", "target"]);
    let currentPersonType = usePersonTypeInternalName();
    let currentApp = useVirtualizedApp().name;
    // If we're already on the student page, we want to keep all the params we currently have.
    const isOnStudentPage = !!((_b = useLocation().pathname) === null || _b === void 0 ? void 0 : _b.match(/^\/aviso\/.+\/app\/advisor\/people/));
    const params = useParams();
    const paramsToUse = isOnStudentPage
        ? Object.assign(Object.assign({}, params), (queryParams || {})) : queryParams;
    currentPersonType = personType !== null && personType !== void 0 ? personType : currentPersonType;
    currentApp = virtualizedApp !== null && virtualizedApp !== void 0 ? virtualizedApp : currentApp;
    const personTypesEnabled = useConfiguration("personTypeImportEnabled") === "true";
    const getLink = () => __awaiter(void 0, void 0, void 0, function* () {
        if (personIsInAppAndPersonType) {
            return PersonDomainService.makeLinkToPerson({
                affiliationId,
                tabId,
                personType: currentPersonType,
                /* TODO do this a better way - this is just preventing trying to create a person link to the admin app */
                virtualizedApp: currentApp === "app" ? null : currentApp,
                queryParams: paramsToUse,
            });
        }
        if (!personTypesEnabled) {
            return PersonDomainService.makeLinkToPerson({
                affiliationId,
                tabId,
                /* TODO do this a better way - this is just preventing trying to create a person link to the admin app */
                virtualizedApp: currentApp === "app" ? null : currentApp,
                personType: PersonTypeDomainService.StudentPersonTypeInternalName,
                queryParams: paramsToUse,
            });
        }
        const people = yield PersonService.peopleFromAffiliationIds([
            affiliationId,
        ]);
        let appPersonTypes = yield PersonTypeService.getAppPersonTypesForPeople([
            people[0].personId,
        ]);
        // @ts-expect-error - TS2322 - Type '{ virtualizedApp: VirtualizedApp; personTypes: PersonType[]; }[]' is not assignable to type '{ [key: string]: { virtualizedApp: VirtualizedApp; personTypes: PersonType[]; }[]; }'.
        appPersonTypes = Object.values(appPersonTypes)[0];
        // Link Resolution logic:
        // Does the current person type and app match?  If so, use current person type and app
        // Does the person exist in this app but not have this person type?
        //   -- can we find the right person type to pick based off the feature? use that person type
        //   -- otherwise, use person type find link
        // Does this person not exist in this app?
        //   -- don't render the link.
        // @ts-expect-error - TS2349 - This expression is not callable.
        const currentAppAppPersonType = appPersonTypes.find(
        // @ts-expect-error - TS7006 - Parameter 'appPersonType' implicitly has an 'any' type.
        (appPersonType) => appPersonType.virtualizedApp.name === currentApp);
        if (
        // Does this person exist in this app?
        currentAppAppPersonType) {
            if (
            // Does this person have a person type in the current app?
            currentAppAppPersonType.personTypes.some(
            // @ts-expect-error - TS7006 - Parameter 'pt' implicitly has an 'any' type.
            (pt) => pt.internalName === currentPersonType)) {
                return PersonDomainService.makeLinkToPerson({
                    affiliationId,
                    tabId,
                    personType: currentPersonType,
                    virtualizedApp: currentApp,
                    queryParams: paramsToUse,
                });
            }
            // TODO try to figure out which person type to pick
            return PersonDomainService.makeLinkToPerson({
                affiliationId,
                tabId,
                personType: null,
                virtualizedApp: currentApp,
                queryParams: paramsToUse,
            });
        }
        return PersonDomainService.makeLinkToPerson({
            affiliationId,
            tabId,
            personType: null,
            virtualizedApp: null,
            queryParams: paramsToUse,
        });
    });
    const history = useHistory();
    return (_jsx("button", { role: "link", className: "btn btn-link p-0 " + (className || ""), onClick: (e) => {
            e.stopPropagation();
            getLink().then((link) => {
                if (target === "_blank") {
                    window.open(link, "_blank");
                }
                else {
                    history.push(link);
                }
            });
        }, title: `Go to ${name || "person"}`, style: otherProps.style, children: children }));
};
export default LinkToPerson;
